module.exports = __webpack_public_path__ + "static/medal-fad594527dae8d30834931b3dcb8dd78.svg";